import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import Echo, { Channel } from 'laravel-echo';
import { AuthenticationService } from './authentication.service';
import { Organisation } from '../../interfaces/routering/organisation';
import { environment } from '../../../environments/environment';
import { User } from '../../interfaces/routering/user';
import { LocalStorageService } from './local-storage.service';
import Pusher from 'pusher-js';

@Injectable({
  providedIn: 'root'
})

export class BroadcastService {

  private eventSubjects: { [key: string]: Subject<any> } = {};

  private channelSubscription: Channel = null;

  constructor(private authenticationService: AuthenticationService,
              private localStorageService: LocalStorageService,
  ) {
    this.authenticationService.user$.subscribe((user: User): void => {
      if (user) {
        if (typeof window.Echo === 'undefined' && typeof Pusher !== 'undefined') {
          window.Echo = new Echo({
            ...environment.pusher,
            ...{
              authEndpoint: environment.api_endpoint + 'broadcasting/auth',
              auth: {
                headers: {
                  Accept: 'application/json',
                  Authorization: `Bearer ${this.localStorageService.get('api-token')}`
                }
              }
            }
          });
        }

        this.subscribeToChannel();
      }
    });
  }

  private subscribeToChannel(): void {
    this.authenticationService.organisation$.subscribe((organisation: Organisation): void => {
      if (organisation) {
        const channel: Channel = window.Echo.private('organisation.' + organisation.name.toLowerCase());

        if (this.channelSubscription !== null) {
          channel.stopListening('.events');
        }

        this.channelSubscription = channel.listen('.events', (data: any): void => {
          const eventKey: string = `${data.modelName}.${data.eventType}`;
          if (!environment.production) {
            console.log('WebSocket: received event for ' + eventKey + ', with data:', data);
          }

          if (!this.eventSubjects[eventKey]) {
            this.eventSubjects[eventKey] = new Subject();
          }

          this.eventSubjects[eventKey].next(data);
        });
      }
    });
  }

  /**
   * Get the event data subject for a specific model and event type.
   *
   * @param modelName
   * @param eventType
   *
   * @returns The BehaviorSubject that holds the event data
   */
  getEventSubject(modelName: string, eventType: string): Subject<any> {
    const eventKey: string = `${modelName}.${eventType}`;

    if (!this.eventSubjects[eventKey]) {
      this.eventSubjects[eventKey] = new Subject<any>();
    }

    return this.eventSubjects[eventKey];
  }

  /**
   * Clear BehaviorSubject event
   *
   * @param {string} eventName
   */
  clearEventSubject(eventName: string): void {
    if (this.eventSubjects[eventName]) {
      delete this.eventSubjects[eventName];
    }
  }
}
